<template>
<div class="chapter">
<div class="inner_page">
<div class="image_wrap">
<p class="image_horiz"><a id="page_2"></a><span class="weblink"><a href="http://www.chroniclebooks.com/" target="_blank"><img alt="image" height="auto" src="images/f0002-01.jpg" width="100%"/></a></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01title.vue?a9207bd6